import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { WorkspaceLoadingService } from '../../../shared/misc-services/workspace-loading.service';
import { pauseTaskIcon } from '../../shared/icons/pause-task-icon';
import { StopWorkService } from '../stop-work-button/stop-work.service';
import { TimerService } from '../timer-badge/timer.service';

@Component({
  selector: 'h3-pause-task-dialog',
  templateUrl: './pause-task-dialog.component.html',
  styleUrl: './pause-task-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PauseTaskDialogComponent {
  private readonly timerService = inject(TimerService);
  private readonly workspaceLoadingService = inject(WorkspaceLoadingService);
  private readonly matDialogRef = inject(MatDialogRef);
  private readonly stopWorkService = inject(StopWorkService);

  protected pauseTaskIcon = pauseTaskIcon;
  protected currentDuration = this.timerService.elapsed();
  protected targetDuration = this.timerService.targetDuration;
  protected isLoading$ = this.workspaceLoadingService.isLoading$;
  protected isDurationVisible = this.timerService.isVisible;

  stopWork() {
    this.matDialogRef.disableClose = true;
    try {
      this.stopWorkService.stopWork('pause', false);
    } catch (e) {
      this.workspaceLoadingService.isLoading$.next(false);
      this.matDialogRef.disableClose = false;
      throw e;
    }
  }
}
